module.exports = __webpack_public_path__ + "img/teasers_9.3ebd3bbb.jpg";